import type { IVDropdownOption } from '~/misc/v-dropdown/types';
import { EFeatureName } from '~/misc/feature/types';
import type { TAutomatedEmailProvider } from '~/modules/manager/types';

const MANAGER_FEATURE_LABELS: Record<EFeatureName, string> = {
  [EFeatureName.OPPORTUNITY_SEARCH_ANNIVERSARY]: 'Anniversary',
  [EFeatureName.DOWNLOAD_MARKET_DATA]: 'Market Download',
  [EFeatureName.OPPORTUNITY_SEARCH_WITHDRAWN]: 'Withdrawn',
  [EFeatureName.OPPORTUNITY_SEARCH_LIKELY_SOLD]: 'Likely Sold',
  [EFeatureName.PITCH_PANEL]: 'Pitch Panel',
  [EFeatureName.ROI_DASHBOARD]: 'ROI Dashboard',
  [EFeatureName.UPLOAD_DATA]: 'Upload data',
  [EFeatureName.AUTOMATED_EMAIL]: 'Automated Email',
};

const generateOption = (feature: EFeatureName): IVDropdownOption<string, EFeatureName> => ({
  label: MANAGER_FEATURE_LABELS[feature],
  value: feature,
});

// TODO: put features in order through app
const MANAGER_FEATURE_OPTIONS: IVDropdownOption<string, EFeatureName>[] = [
  EFeatureName.OPPORTUNITY_SEARCH_ANNIVERSARY,
  EFeatureName.DOWNLOAD_MARKET_DATA,
  EFeatureName.OPPORTUNITY_SEARCH_WITHDRAWN,
  EFeatureName.OPPORTUNITY_SEARCH_LIKELY_SOLD,
  EFeatureName.PITCH_PANEL,
  EFeatureName.ROI_DASHBOARD,
  EFeatureName.UPLOAD_DATA,
  EFeatureName.AUTOMATED_EMAIL,
].map(generateOption);

const DEFAULT_AUTOMATED_EMAIL_PROVIDER: TAutomatedEmailProvider = 'mailgun';

const AUTOMATED_EMAIL_PROVIDER_LABELS: Record<TAutomatedEmailProvider, string> = {
  mailgun: 'Mailgun',
  sendgrid: 'Sendgrid',
};

const toAutomatedEmailProviderOption = (
  provider: TAutomatedEmailProvider
): IVDropdownOption<string, TAutomatedEmailProvider> => ({
  label: AUTOMATED_EMAIL_PROVIDER_LABELS[provider],
  value: provider,
});

export {
  MANAGER_FEATURE_LABELS,
  MANAGER_FEATURE_OPTIONS,
  DEFAULT_AUTOMATED_EMAIL_PROVIDER,
  AUTOMATED_EMAIL_PROVIDER_LABELS,
  toAutomatedEmailProviderOption,
};
